import { CheckCircle, Search } from "@mui/icons-material";
import type React from "react";
import styles from "../styles.module.scss";
import type { PluginSearchResult } from "../types";

interface PluginSearchResultsSectionProps {
  pluginResults: PluginSearchResult;
}

const PluginSearchResultsSection: React.FC<PluginSearchResultsSectionProps> = ({
  pluginResults,
}) => {
  if (pluginResults.results.length === 0) return null;

  return (
    <section className={styles["pluginResultsSection"]} aria-label="プラグイン検索結果">
      <header className={styles["pluginResultsHeader"]}>
        <div className={styles["pluginResultsHeading"]}>
          <Search className={styles["pluginResultsIcon"] || ""} aria-hidden="true" />
          <span className={styles["pluginResultsTitle"]}>情報取得</span>
          <span className={styles["pluginResultsStatus"]}>
            <CheckCircle aria-hidden="true" />
            完了
          </span>
        </div>
        <span className={styles["pluginResultsCount"]}>{pluginResults.results.length}件</span>
      </header>

      <div className={styles["pluginResultsContent"]}>
        <div className={styles["pluginResultsList"]}>
          {pluginResults.results.map((plugin, index) => (
            <p key={`${plugin.name}-${plugin.url}`} className={styles["pluginResultItem"]}>
              <strong className={styles["pluginResultName"]}>{plugin.name}:</strong>{" "}
              <span>{plugin.description}</span>{" "}
              <a
                className={styles["pluginResultReference"]}
                href={plugin.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`[${index + 1}] ${plugin.name}の詳細`}
              >
                [{index + 1}]
              </a>
            </p>
          ))}
        </div>

        <div className={styles["pluginReferences"]}>
          <h4 className={styles["pluginReferencesTitle"]}>参考URL</h4>
          <ol className={styles["pluginReferencesList"]}>
            {pluginResults.results.map((plugin, index) => (
              <li key={plugin.url}>
                <a href={plugin.url} target="_blank" rel="noopener noreferrer">
                  [{index + 1}] {plugin.name}（{plugin.company}）
                </a>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default PluginSearchResultsSection;
